define('SageDotCom/DataLayer/Global/brightcove-video-tracker',[
    "jquery",
    "SageDotCom/DataLayer/Events/video-interaction",
    "SageDotCom/DataLayer/Events/ga4-video-interaction",
    "eventManager"

],
    function ($, VideoInteractionEvent, Ga4VideoInteractionEvent, eventManager) {

        function BrightcoveVideoTracker() {
        }

        function onPlayerEventDetected(playerDetails) {

            if (playerDetails.eventType === "play" && playerDetails.currentTime === 0) {
                //The video began playing for the first time or after 100% play completion ("video_start" event)
                new VideoInteractionEvent(playerDetails, false).trigger();
                playerDetails.eventType = "firstplay";
                new Ga4VideoInteractionEvent(playerDetails, false, false, true).trigger();
            }
            else if (playerDetails.eventType === "seeked") {
                new Ga4VideoInteractionEvent(playerDetails, false, true, false).trigger();
            }
            else if (playerDetails.eventType === "milestone" && playerDetails.milestone !== 0) {
                new VideoInteractionEvent(playerDetails, true).trigger();
                new Ga4VideoInteractionEvent(playerDetails, true, false, false).trigger();
            }
            else if (playerDetails.eventType === "play" || playerDetails.eventType === "pause" || playerDetails.eventType === "ended") {
                // brightcove sends extra pause event at the end of a video which is not wanted for our tracking
                if (!(playerDetails.eventType === "pause" && playerDetails.currentTime === playerDetails.duration)) {
                    new VideoInteractionEvent(playerDetails, false).trigger();
                    new Ga4VideoInteractionEvent(playerDetails, false, false, false).trigger();
                }
            }
        }

        function populateEventDetails(player, eventType) {
            var playerInfo = {
                state: player.paused() ? 'paused' : 'playing',
                eventType: eventType,
                currentTime: player.currentTime(),
                duration: player.duration(),
                muted: player.muted(),
                videoId: player.mediainfo.id,
                videoName: player.mediainfo.name,
                videoTitle: player.mediainfo.name,
                videoUrl: player.currentSrc(),
                milestone: eventType === "ended" ? "100" : calculateMilestone(player),
                isBrightcove: true,
                volume: Math.round(player.volume() * 100)
            };

            onPlayerEventDetected(playerInfo);
        }

        function fireMilestoneEvent(player) {
            var previouslyReachedMilestone = player.milestoneTrackingMilestone !== undefined ? player.milestoneTrackingMilestone : -1;
            var milestone = calculateMilestone(player);

            if (milestone > previouslyReachedMilestone) {
                // new milestone reached so send milestone event
                player.milestoneTrackingMilestone = milestone;
                populateEventDetails(player, "milestone");
            }
            else {
                player.milestoneTrackingMilestone = previouslyReachedMilestone;
            }
        }

        function calculateMilestone(player) {
            var milestones = [0, .1, .25, .5, .75, .9];
            const isMilestone = (m) => (player.currentTime() / player.duration()) >= m;
            var milestoneIndex = milestones.findLastIndex(isMilestone);
            return (milestones[milestoneIndex]) * 100;
        }

        function trackBrightcoveVideosIn(container) {

            // The event should only be fired after the window has received the 'load' event; otherwise, it may cause an error
            window.onload = function () {

                // for setting up tracking on the scrore brightcove videos
                if ($('.brightcove-media-container-js') !== null && $('.brightcove-media-container-js').length > 0) {
                    for (var i = 0; i < Object.keys(videojs.getPlayers()).length; i++) {
                        var playerId = Object.keys(videojs.players)[i];
                    
                        // Define the ready event for the player
                        var player = videojs.getPlayer(playerId);

                        player.on("firstplay", function (event) {
                            populateEventDetails(event.target.player, "firstplay");
                        });
                        player.on("play", function (event) {
                            populateEventDetails(event.target.player, "play");
                        });
                        player.on("pause", function (event) {
                            populateEventDetails(event.target.player, "pause");
                        });
                        player.on("ended", function (event) {
                            populateEventDetails(event.target.player, "ended");
                        });
                        player.on("seeked", function (event) {
                            populateEventDetails(event.target.player, "seeked");
                        });
                        player.on("timeupdate", function (event) {
                            // make sure that it only fires when event comes from video element, not progress bar like after seek event
                            if (event.target.tagName === "DIV" && event.target.classList.contains("video-js")) {
                                fireMilestoneEvent(event.target.player);
                            }
                        });
                    }
                }
            };
            
        }

        BrightcoveVideoTracker.prototype.start = function () {

            trackBrightcoveVideosIn(document.body);
        }

        return BrightcoveVideoTracker;
    });
